import { useMatch } from "react-router-dom";
import { Body } from "../body/Body";
import { BorderBar, Content } from "../tab/Tab.Parts";
import { Props, Tab } from "./NavTab.Parts";

export const NavTab = ({ $disabled, onClick, label = "", ...props }: Props) => {
  const pathname = props.to.toString().split("?")[0];
  const match = useMatch(pathname);
  const isActive = Boolean(match);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if ($disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick?.(e);
  };

  return (
    <Tab
      $disabled={$disabled}
      tabIndex={$disabled || isActive ? -1 : undefined}
      onClick={handleClick}
      {...props}
    >
      <Content>
        <Body variant="normal-strong">{label}</Body>
      </Content>
      <BorderBar $active={isActive} />
    </Tab>
  );
};
